export default "__VITE_ASSET__C2uuWaXy__"